import styled from "@mui/system/styled"

const InputGroup = styled("div")({
  display: "flex",
  gap: "16px",
})

export default InputGroup
